export enum HolidayRequestStatus {
	Pending = 0,
	Approved = 10,
	Declined = 20,
	Revoked = 30,
}